import classes from "./Subscribe.module.css";
import { Formik, useField, Form } from "formik";
import * as Yup from "yup";
import { ButtonPrimary } from "../../../../components/Button/Button";
import { useNavigate } from "react-router-dom";

const MyTextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input className="text-input" {...field} {...props} />
      {meta.touched && meta.error ? (
        <div className={classes.error}>{meta.error}</div>
      ) : null}
    </>
  );
};

const Subscribe = ({ className }) => {
  const navigate = useNavigate();

  return (
    <section className={`${className} ${classes.subscribe}`}>
      <Formik
        initialValues={{ name: "", email: "" }}
        validationSchema={Yup.object({
          name: Yup.string().required("必填"),
          email: Yup.string().email("請填寫正確的信箱").required("必填"),
        })}
        onSubmit={(values, { setSubmitting }) => {
          navigate("subscribe-success");
        }}
      >
        <Form className={classes.subs}>
          <div className={classes.subs__inputContainer}>
            <p className={classes.subs__title}>獲得最新消息</p>
            <MyTextInput
              name="name"
              type="text"
              className={classes.subs__input}
              placeholder="姓名"
            />
            <MyTextInput
              name="email"
              type="email"
              className={classes.subs__input}
              placeholder="信箱"
            />
            <ButtonPrimary
              text="加入電子報"
              type="submit"
              className={`${classes.subs__button}`}
            />
          </div>
        </Form>
      </Formik>
    </section>
  );
};

export default Subscribe;
